import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Header, Button, Container, Grid, Message, Icon, Input } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import TimerContainer from '../TimerContainer.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';

import styleDef from './style.js';
const style = {
    ...styleDef,
    containerExpanded: {
        padding:'0px 10px 0px 10px',
    },
}


const TimerScreen = ({t,
                      challenge, 
                      duration, 
                      onComplete,
                      onChange, 
                      completePending, 
                      userChallenge}) => (
    <Container style={{...style.container, ...style.containerExpanded}}>
        <div style={style.containerDiv}>
            <Segment style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <Grid.Row verticalAlign='top' style={style.topRow}>
                        <Grid.Column verticalAlign='top'>
                            <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>
                            <Instructions challenge={challenge} />
                            <TimerContainer duration={duration} run={true} onComplete={onComplete} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row verticalAlign='bottom'>
                        <Grid.Column verticalAlign='bottom' textAlign='center'>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </div>
    </Container>
);

export default translate('challenges')(TimerScreen);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/TimerScreen.js